/**
 * Arbitrary JSON, typed.
 *
 * Exists so the places that genuinely handle "whatever JSON arrived" — the
 * OpenAPI document the API builds, the JSON-RPC body the MCP endpoint forwards,
 * the half-finished document a marketing form is holding — can say so precisely
 * instead of reaching for `unknown`, which `cse/no-unknown-type` forbids and
 * which would lose the shape entirely.
 *
 * In `lib` rather than in either app because both need it and two structurally
 * identical definitions are two things to drift.
 */
export type Json = string | number | boolean | null | Json[] | { [key: string]: Json }

/**
 * JSON as a database column hands it back: like `Json`, but an object's keys may
 * be absent (Prisma's `JsonValue` types them optional). For reading a stored
 * column into a schema, which decides what it actually holds.
 */
export type StoredJson =
  | string
  | number
  | boolean
  | null
  | readonly StoredJson[]
  | { readonly [key: string]: StoredJson | undefined }

/** A JSON object specifically, which is what every document here is at the top. */
export type JsonObject = { [key: string]: Json }

/** Whether a value is a JSON object rather than a list, a primitive, or null. */
export function isJsonObject(value: Json | undefined): value is JsonObject {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}
